import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { cityList } from '../data/cityList';

@Component({
  selector: 'mobile-be-our-dealer',
  templateUrl: './mobile-be-our-dealer.component.html',
  styleUrls: []
})
export class MobileBeOurDealerComponent implements OnInit {
  darkMode = false;
  loading = false;
  cityList: any = [];

  dealerForm: FormGroup;
  nameValid = true;
  mailValid = true;
  phoneValid = true;
  provinceValid = true;
  districtValid = true;
  formValid = false;

  constructor(private route: ActivatedRoute, private http: HttpClient) {
    try {
      const mode = this.route.snapshot.queryParams['mode'];
      this.darkMode = mode === '0' || mode === 0;
      const darkClass = this.darkMode ? 'dark' : '';
      document.documentElement.className = darkClass;
      document.body.className = darkClass;
    } catch (e) { }
    window.scrollTo(0, 0);
    this.cityList = cityList;
    this.dealerForm = new FormGroup({
      company: new FormControl(),
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
      ]),
      phone: new FormControl('', [Validators.required]),
      province: new FormControl('', [Validators.required]),
      district: new FormControl('', [Validators.required]),
      website: new FormControl(),
      message: new FormControl('', [Validators.required])
    });
    this.dealerForm.controls['province'].setValue(0);
  }

  ngOnInit() {
    this.prefillFromQueryParams();
  }

  private prefillFromQueryParams() {
    const q = this.route.snapshot.queryParams;
    const company = q['company'];
    const nameParam = q['name'];
    const surname = q['surname'];
    const email = q['email'];
    const phone = q['phone'];
    const fullName = [nameParam, surname].filter(Boolean).join(' ').trim();
    if (company) this.dealerForm.patchValue({ company });
    if (fullName) this.dealerForm.patchValue({ name: fullName });
    if (email) this.dealerForm.patchValue({ email });
    if (phone) this.dealerForm.patchValue({ phone });
  }

  onSubmit() {
    this.loading = true;
    this.nameValid = this.dealerForm.controls['name'].valid;
    this.mailValid = this.dealerForm.controls['email'].valid;
    this.phoneValid = this.dealerForm.controls['phone'].valid;
    this.provinceValid = this.dealerForm.controls['province'].value !== '0';
    this.districtValid = this.dealerForm.controls['district'].valid;

    if (this.nameValid && this.mailValid && this.phoneValid && this.provinceValid && this.districtValid) {
      this.saveInfo();
    } else {
      this.loading = false;
    }
  }

  checkPhone() {
    const val = this.dealerForm.controls['phone'].value;
    if (val && val[0] === '0') {
      this.dealerForm.controls['phone'].setValue(val.substr(1));
    }
  }

  saveInfo() {
    const url = environment.notificationUrl + '/v1/notifications/email';
    const raw = this.dealerForm.getRawValue();
    const req = {
      subject: "(APP) Bayimiz Olun Başvurusu",
      params: {
        "Firma İsmi": raw.company,
        "Yetkili Ad Soyad": raw.name,
        "Telefon": raw.phone,
        "E-Posta": raw.email,
        "İl": raw.province,
        "İlçe": raw.district,
        "Web Sitesi": raw.website,
        "Mesaj": raw.message
      }
    };
    this.http.post(url, req).subscribe(
      () => {
        this.loading = false;
        this.formValid = true;
      },
      () => {
        this.loading = false;
        this.formValid = true;
      }
    );
  }
}
